import { t } from "ttag";

import { Header } from "@/shared/ui";

export const DocumentCenterHeader = () => {
  return (
    <Header.Root>
      <Header.Content>
        <Header.Title>{t`Document center`}</Header.Title>

        <Header.Description>
          {t`View, manage, and upload your health documents easily.`}
        </Header.Description>
      </Header.Content>
    </Header.Root>
  );
};
